document.addEventListener('DOMContentLoaded', function () {

    const grid = document.getElementById('products-grid');
    const scrollTrigger = document.getElementById('scroll-trigger');

    if (!grid || !scrollTrigger) return;

    const collectionHandle = grid.dataset.handle;
    const initialLimit = parseInt(grid.dataset.initialLimit, 10) || 8;
    const currency = grid.dataset.currency;
    const locale = grid.dataset.locale;

    const searchInput = document.getElementById('collection-search-input');
    const dropdown = document.getElementById('sortDropdown');
    const sortButton = dropdown ? dropdown.querySelector('button') : null;
    const sortItems = dropdown ? dropdown.querySelectorAll('.sort-item') : [];
    const viewButtons = document.querySelectorAll('.view-toggle button');
    const groups = document.querySelectorAll('.filter-group');
    const clearAllBtn = document.getElementById('clearFilters');
    const activeEl = document.getElementById('activeFilters');
    const filtersList = activeEl ? activeEl.querySelector('.filters-list') : null;

    let selected = Array(groups.length).fill(null);
    let page = 2;
    let loading = false;
    let noMoreProducts = false;
    let autoFetchCount = 0;

    const params = new URLSearchParams(window.location.search);
    const urlTag = params.get('filter_tag');
    const targetTag = urlTag ? urlTag.trim().toLowerCase() : null;

    function debounce(fn, wait) {
        let timeout;
        return function () {
            clearTimeout(timeout);
            timeout = setTimeout(() => fn.apply(this, arguments), wait);
        };
    }

    function updatePriceStacking() {
        document.querySelectorAll('.price-wrapper').forEach(wrap => {
            wrap.classList.toggle('stacked', wrap.scrollWidth > wrap.clientWidth);
        });
    }

    function updateActiveFiltersUI() {
        if (!filtersList || !activeEl) return;
        filtersList.innerHTML = '';
        let hasFilters = false;

        selected.forEach((tag, idx) => {
            if (tag) {
                hasFilters = true;
                const pill = document.createElement('span');
                pill.className = 'filter-pill';
                const groupTitleEl = groups[idx].querySelector('h3');
                const tagEl = groups[idx].querySelector(`[data-tag="${tag}"]`);

                const title = groupTitleEl ? groupTitleEl.textContent : 'Filter';
                const label = tagEl ? tagEl.textContent : tag;

                pill.innerHTML = `
            <div class="pill-text"><span class="pill-title">${title}: </span><span class="pill-tag">${label}</span></div>
            <span class="remove" data-index="${idx}">×</span>
            `;
                filtersList.appendChild(pill);
            }
        });
        activeEl.style.display = hasFilters ? 'block' : 'none';
    }

    function applyFiltersAndSearch() {
        const q = searchInput ? searchInput.value.trim().toLowerCase() : '';

        const cards = Array.from(grid.querySelectorAll('.product-card'));

        let visibleCount = 0;

        cards.forEach(card => {
            const title = card.querySelector('h4').textContent.toLowerCase();
            const tagsData = card.dataset.tags || '';
            const tags = tagsData.toLowerCase().split(',');

            const tagsOk = selected.every((t, i) => !t || tags.includes(t));
            const textOk = !q || title.includes(q);

            if (tagsOk && textOk) {
                card.style.display = '';
                visibleCount++;
            } else {
                card.style.display = 'none';
            }
        });

        if (dropdown) {
            const activeSort = dropdown.querySelector('.sort-item.active');
            const sortVal = activeSort ? activeSort.dataset.sort : 'default';

            const visibleCards = cards.filter(c => c.style.display !== 'none');

            if (sortVal === 'price-asc') {
                visibleCards.sort((a, b) => parseFloat(a.dataset.price) - parseFloat(b.dataset.price));
            } else if (sortVal === 'price-desc') {
                visibleCards.sort((a, b) => parseFloat(b.dataset.price) - parseFloat(a.dataset.price));
            }

            visibleCards.forEach(c => grid.insertBefore(c, scrollTrigger));
        }

        updateActiveFiltersUI();
        updatePriceStacking();
        autoFetchCount = 0;

        requestAnimationFrame(checkAndFillScreen);
    }

    function checkAndFillScreen() {
        if (loading || noMoreProducts) return;

        const visibleCount = grid.querySelectorAll('.product-card:not([style*="display: none"])').length;

        const triggerRect = scrollTrigger.getBoundingClientRect();
        const isTriggerVisible = triggerRect.top <= window.innerHeight + 50;

        if ((visibleCount < 8 && autoFetchCount < 4) || isTriggerVisible) {
            
            if (!isTriggerVisible) {
                autoFetchCount++;
            } else {
                autoFetchCount = 0; 
            }
            
            loadMore();
        }
    }

    function loadMore() {
        if (loading || noMoreProducts) return;
        loading = true;

        grid.classList.add('is-loading');

        fetch(`/collections/${collectionHandle}?view=ajax&page=${page}`)
            .then(res => {
                if (!res.ok) throw new Error('Network error');
                return res.text();
            })
            .then(html => {
                const temp = document.createElement('div');
                temp.innerHTML = html;
                const cards = temp.querySelectorAll('.product-card');

                if (!cards.length) {
                    noMoreProducts = true;
                    if (observer) observer.disconnect();
                    return;
                }

                cards.forEach(c => grid.insertBefore(c, scrollTrigger));

                page++;

                applyFiltersAndSearch();
            })
            .catch(err => {
                console.error('Loading failed：', err);
                noMoreProducts = true;
            })
            .finally(() => {
                loading = false;
                grid.classList.remove('is-loading');
                checkAndFillScreen();
            });
    }

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting && !loading && !noMoreProducts) {
                loadMore();
            }
        });
    }, {
        rootMargin: '200px',
        threshold: 0
    });

    observer.observe(scrollTrigger);

    if (searchInput) {
        searchInput.addEventListener('input', debounce(() => {
            applyFiltersAndSearch();
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }, 300));
    }

    if (sortButton && dropdown) {
        sortButton.addEventListener('click', e => {
            e.stopPropagation();
            dropdown.classList.toggle('open');
        });

        document.addEventListener('click', () => dropdown.classList.remove('open'));

        sortItems.forEach(item => item.addEventListener('click', () => {
            sortItems.forEach(i => i.classList.remove('active'));
            item.classList.add('active');
            applyFiltersAndSearch();
        }));
    }

    viewButtons.forEach(btn => btn.addEventListener('click', () => {
        viewButtons.forEach(b => b.classList.remove('active'));
        btn.classList.add('active');
        grid.classList.toggle('view-2', btn.dataset.view === '2');
        grid.classList.toggle('view-4', btn.dataset.view === '4');
        checkAndFillScreen();
    }));

    groups.forEach((group, i) => {
        group.classList.add('expanded');
        const btn = group.querySelector('.toggle-btn');
        if (btn) btn.setAttribute('aria-expanded', 'true');

        const hdr = group.querySelector('.filter-group-header');
        if (hdr) {
            hdr.addEventListener('click', () => {
                const exp = group.classList.toggle('expanded');
                const b = group.querySelector('.toggle-btn');
                if (b) b.setAttribute('aria-expanded', exp);
            });
        }

        group.querySelectorAll('.filter-tag').forEach(tagBtn => {
            const tag = tagBtn.dataset.tag;

            if (targetTag && tag === targetTag) {
                selected[i] = tag;
                tagBtn.classList.add('active');
                group.classList.add('expanded');
            }

            tagBtn.addEventListener('click', () => {
                if (selected[i] === tag) {
                    selected[i] = null;
                    tagBtn.classList.remove('active');
                } else {
                    selected[i] = tag;
                    group.querySelectorAll('.filter-tag').forEach(t => t.classList.remove('active'));
                    tagBtn.classList.add('active');
                }

                window.scrollTo({ top: 0, behavior: 'smooth' });
                applyFiltersAndSearch();
            });
        });
    });

    if (clearAllBtn) {
        clearAllBtn.addEventListener('click', () => {
            selected.fill(null);
            groups.forEach(g => g.querySelectorAll('.filter-tag').forEach(t => t.classList.remove('active')));
            window.scrollTo({ top: 0, behavior: 'smooth' });
            applyFiltersAndSearch();
        });
    }

    if (filtersList) {
        filtersList.addEventListener('click', function (e) {
            if (e.target.closest('.remove')) {
                const idx = e.target.closest('.remove').dataset.index;
                selected[idx] = null;
                groups[idx].querySelectorAll('.filter-tag').forEach(t => t.classList.remove('active'));
                applyFiltersAndSearch();
            }
        });
    }

    applyFiltersAndSearch();

    const megaLinks = document.querySelectorAll('.mega-menu-wrapper a[href*="filter_tag"]');

    megaLinks.forEach(link => {
        link.addEventListener('click', function (e) {
            const targetUrl = new URL(this.href);
            const currentPath = window.location.pathname;

            const cleanTarget = targetUrl.pathname.replace(/\/$/, '');
            const cleanCurrent = currentPath.replace(/\/$/, '');

            if (cleanTarget === cleanCurrent) {
                e.preventDefault();

                const params = new URLSearchParams(targetUrl.search);
                const newTag = params.get('filter_tag');

                if (newTag) {
                    const tagLower = newTag.trim().toLowerCase();

                    window.history.pushState({}, '', this.href);

                    selected.fill(null);
                    groups.forEach(g => {
                        g.querySelectorAll('.filter-tag').forEach(t => t.classList.remove('active'));
                    });

                    let found = false;
                    groups.forEach((group, idx) => {
                        const tagBtn = group.querySelector(`.filter-tag[data-tag="${tagLower}"]`);
                        if (tagBtn) {
                            selected[idx] = tagLower;
                            tagBtn.classList.add('active');
                            group.classList.add('expanded');
                            const toggle = group.querySelector('.toggle-btn');
                            if (toggle) toggle.setAttribute('aria-expanded', 'true');
                            found = true;
                        }
                    });

                    if (found) {
                        applyFiltersAndSearch();
                        window.scrollTo({ top: gridTop, behavior: 'smooth' });
                    }
                }
            }
        });
    });

});